import ReactSelect from "components/Form/Select/Select";
import rest from "lib/rest";
import React, { useEffect, useState } from "react";
import TagsInput from "react-tagsinput";
import { Button, Col, FormGroup, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import rotas from "services/rotas";
import Swal from "sweetalert2";
import RetornoSmartPed from "./RetornoSmartPed";
import Iframe from "react-iframe";
import { homepage } from '../../../../../package.json';

const SmartPed = ({ onClose, gerarCotacao, produtos, filial_id }) => {

  const initialParams = {
    nomeCotacao:'',
    nomeResponsavel:'',
    fornecedores:[]
  }
  
  const [listaFornecedores, setListaFornecedores] = useState(initialParams);
  const [parametros, setParametros] = useState({});
  const [retorno, setRetorno] = useState([]);
  const [pathPDF, setPathPdf] = useState('');
  const [modalPdf, setModalPdf] = useState(false);

  useEffect(()=>{
    listarFornecedores();
    
  },[])

  // const listarRetorno = () =>{
  //   let retorno = rest.get('/webgestor/api/pedidos/assistente/cotacao/smartped/retorno.json');

  //   retorno.then(ret=>{
  //     if(ret.Mensagem == 'OK'){        
  //       setRetorno(ret.Retorno);
  //     }
  //   })
  // }

  const listarFornecedores = () =>{
    const url = rotas.fornecedoresPedidos;

    const retorno = rest.get(url);

    retorno.then(ret=>{
      if(ret.success == 'S'){
        let forn = [];

        ret.lista.map(fornecedor=>{
          forn.push({id:fornecedor.fornecedor_id,
                      title:fornecedor.fornecedor,
                      forn_cnpj:fornecedor.forn_cnpj
          })
        })
        setListaFornecedores(forn);
      }
    })
  }

  const onChangeParametros = (e) =>{
    let param = {...parametros};
    param[e.target.name] = (e.target.value.toUpperCase != undefined) ? e.target.value.toUpperCase() : e.target.value;

    setParametros(param);
  }

  const onChangeForn = (e, name) =>{
    if(e == null){
      e = [];
    }
    let param = {
      type: 'select',
      target: {
        name: name,
        value: e
      }
    }
    onChangeParametros(param);
  }

  const validaCodBarrasVazio = () =>{
    let res = true;
    produtos.map(produto=>{
      if((produto.cod_barras == null) || (produto.cod_barras == '')){
        res = false
      }
    })    
    return(res);
  }

  const preValidacoesCotacao = () =>{
    let valida = validaCodBarrasVazio();
    
    if(valida == false){
      Swal.fire({
        title: "Existem produtos sem código de barras, eles não serão cotados, enviar os demais produtos?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "SIM",
        showLoaderOnConfirm: true,}
      ).then(response=>{
        if(response.isConfirmed){
          gerarSmartPed();
        }
      })
    }else{
      gerarSmartPed();
    }  
  }

  const imprimirSmartPed = () =>{
    const url = rotas.pedidoSmartPedImprimir;

    const parametros = {
      produtos:retorno
    }

    const ret = rest.post(url,parametros);

    ret.then(ret=>{
      if(ret.success == 'S'){
        setPathPdf(homepage + '/webgestor/api/pedidos/assistente/impressao/smartped' + ret.path);
        setModalPdf(true)
      }
    })
  }

  const gerarSmartPed = () =>{

    Swal.fire({
      title: "Confirma o envio da cotação?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "SIM",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        const url = rotas.pedidoSmartPed;
        
        let params={
          fornecedores:parametros.fornecedores,
          filial_id:filial_id,
          produtos:produtos    
        }

        return rest.post(url, params);
      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.isConfirmed) {
        if (result.value.success == 'S') { 
          setRetorno(result.value.lista)
          //Swal.fire('Atenção', 'Cotação Enviada com Sucesso!', 'success');
        } else {
          Swal.fire('Atenção', 'Erro ao Enviar a Cotação!', 'warning');
        }
      }
    });

  }

  const changePedir = (codBarras,codDist) =>{
    let ret = {...retorno};    

    ret.itens.map(prod=>{
      if(prod.CodBarra == codBarras){
        prod.Condicoes.map(cond=>{
          if(cond.codigo == codDist){
            cond.pedir = 'S';
            cond.tipoPedir = 'M'
          }else{
            cond.pedir = 'N'
          }
        })
      }
    })

    console.log(ret);

    setRetorno(ret);
  }

  return (
    <>
      <ModalHeader>SmartPed</ModalHeader>
      <Modal
          key     = 'modrelat'
          size    = 'xl'
          height  = "700px"
          isOpen  = {modalPdf}
        >
          <Iframe
            allowFullScreen
            id        = "myId"
            name      = "myId"
            className = "myClassname"
            width     = "100%"
            height    = "580px"
            display   = "initial"
            position  = "relative"
            url       = {pathPDF}
            >
          </Iframe>
          <Row>
            <Col className="text-center p-3">
              <Button
                type      = "button"
                className = "mb-0 mt-0"
                color     = "success"
                size      = "md"
                onClick   = {()=>{window.open(pathPDF)}}
              >Baixar
                </Button>
              <Button
                type      = "button"
                className = "mb-0 mt-0"
                color     = "default"
                size      = "md"
                onClick   = {()=>{setModalPdf(false)}}>Fechar</Button>
            </Col>
          </Row>
        </Modal>

      <ModalBody>
        {/* <Row>
          <Col md="6" className={"pl-0"}>
            <FormGroup className="">              
              <Input
                name="nomeCotacao"                
                placeholder="Nome da cotação"
                onChange={onChangeParametros}
                defaultValue={parametros.nomeCotacao}                  
              />
            </FormGroup>
          </Col>

          <Col md="6" className="pr-0">
            <FormGroup className="">              
              <Input
                name="nomeResponsavel"                
                placeholder="Nome do responsável"
                onChange={onChangeParametros}
                defaultValue={parametros.nomeResponsavel}                
                //defaultValue={calculaMargemApurada()}
              />
            </FormGroup>
          </Col>
        </Row> */}

        <Row>
          <Col className="px-0">
            <FormGroup>
              <ReactSelect
                name="fornecedores"
                placeholder="Selecione os fornecedores"
                options={listaFornecedores}
              //defaultValue= {form.fornecedor}
                onChange={(e)=>{onChangeForn(e,'fornecedores')}}
                isMulti
              ></ReactSelect>
            </FormGroup>
          </Col>
        </Row>

        {/* <Row>
          <Col> */}
            <RetornoSmartPed retorno={retorno} onChangePedir={changePedir}></RetornoSmartPed>
          {/* </Col>
        </Row> */}

      </ModalBody>

      <ModalFooter>
        <Row>
          <Col className="mr-2">
            <Button className="bg-info" onClick={imprimirSmartPed}>Imprimir Pedido</Button>
            <Button className="bg-success" onClick={preValidacoesCotacao}>Gerar Cotação</Button>
            <Button className="bg-danger" onClick={onClose}>Fechar</Button>
          </Col>
        </Row>
      </ModalFooter>
    </>
  );
}

export default SmartPed;  